import React from 'react';
import { Link } from 'react-router-dom';
import './SmartLink.css';

/**
 * Allows you to choose between regular a href vs <link> tag for reload vs push stateurls
 * @param linkUrl - URL to send the user to
 * @param reload - true/false -- if true, use push state url and the <Link> element, else user <a href>
 * @param className - className for link
 * @param text - text to use for Link
 * @param target - href target property
 * @param disabled - html disabled property
 * @param style - html style property
 * @param onClick
 * @returns {*}
 */
export function SmartLink({
  linkUrl,
  reload = false,
  text,
  className,
  target = null,
  disabled = false,
  style = {},
  onClick = null,
}) {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
    }
    if (onClick) {
      onClick();
    }
  };
  if (reload) {
    return (
      <a
        className={`smartLink ${className} ${disabled && 'disabled'}`}
        href={linkUrl}
        target={target}
        onClick={handleClick}
        rel="noopener noreferrer"
        style={style}
      >
        {text}
      </a>
    );
  }
  return (
    <Link className={className} to={linkUrl} onClick={handleClick}>
      {text}
    </Link>
  );
}
